// extracted by mini-css-extract-plugin
export default {"heading":"Cs-z","corrected":"Ds-z","redirectVerbiageContainer":"Es-z","redirectVerbiageText":"Fs-z"};